import { Controller } from "@hotwired/stimulus"

// Auto-dismiss a system toast. Works whether the toast is rendered on page
// load OR appended later via a turbo_stream (Stimulus connects controllers on
// dynamically-inserted nodes), so in-place feed actions can surface feedback
// the same way a full navigation does.
// A toast with an Undo button stays longer, so there is time to reach it.
export default class extends Controller {
    static values = { delay: { type: Number, default: 3500 } }

    connect() {
        this._timer = setTimeout(() => this.element.remove(), this.delayValue)
    }

    disconnect() {
        if (this._timer) clearTimeout(this._timer)
    }
}
